// extracted by mini-css-extract-plugin
export default {"instruction":"InstructionsPane_instruction__k1cL-","codeBlockContainer":"InstructionsPane_codeBlockContainer__q5FaV"};